export const RESERVATION_STATUSES = ['pending_payment', 'confirmed', 'failed', 'cancelled'];

export const RESERVATION_STATUS_TONE = {
  pending_payment: 'pending',
  confirmed: 'paid',
  failed: 'completed',
  cancelled: 'inactive',
};
